var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.167 1.5H4.91699C4.02189 1.5 3.16344 1.85558 2.53051 2.48851C1.89757 3.12145 1.54199 3.97989 1.54199 4.875V43.125C1.54199 44.0201 1.89757 44.8785 2.53051 45.5115C3.16344 46.1444 4.02189 46.5 4.91699 46.5H43.167C44.0621 46.5 44.9205 46.1444 45.5535 45.5115C46.1864 44.8785 46.542 44.0201 46.542 43.125V4.875C46.542 3.97989 46.1864 3.12145 45.5535 2.48851C44.9205 1.85558 44.0621 1.5 43.167 1.5Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/Weight.b8d56341fbabd803ba3cbd37c93220e0.svg";
export { ForwardRef as ReactComponent };